<template>
  <div class="" ref="setH">
    <div class="manageBox">
      <div style="background-color: #fff; padding: 15px 15px 0">
        <ul>
          <li>
            <el-radio-group v-model="search.approvalState" size="small">
              <el-radio-button :label="1">优质资源</el-radio-button>
              <el-radio-button :label="2">专题资源</el-radio-button>
              <el-radio-button :label="3">三师资源</el-radio-button>
            </el-radio-group>
          </li>
        </ul>
      </div>
      <div class="shrink">
        <div class="bg1" :class="shrink ? '' : 'on'" style="min-height: 0px">
          <div class="shrinkRight">
            <el-button type="primary" @click="handleSearch" size="small">查询</el-button>
            <el-button @click="clear" size="small">重置</el-button>
            <el-button size="small" :icon="shrink ? 'el-icon-arrow-left' : 'el-icon-arrow-down'" class="shrinkButton" @click="shrink = !shrink"></el-button>
          </div>
          <div class="searchBox">
            <ul>
              <template v-if="search.approvalState == 1">
                <li>
                  <em>资源名称：</em>
                  <el-input v-model="search.resourceName" size="small" style="width: 250px" placeholder="请输入内容"></el-input>
                </li>
                <li>
                  <em>选择学段：</em>
                  <el-select v-model="search.sectionId" placeholder="选择学段" style="width: 250px" size="small" clearable>
                    <el-option v-for="item in conditions.xueduanList" :key="item.node" :label="item.text" :value="item.node"></el-option>
                  </el-select>
                </li>
                <li>
                  <em>选择年级：</em>
                  <el-select v-model="search.gradeId" placeholder="选择年级" style="width: 250px" size="small" clearable>
                    <el-option v-for="item in conditions.nianjiList" :key="item.node" :label="item.text" :value="item.node"></el-option>
                  </el-select>
                </li>
                <li>
                  <em>选择学科：</em>
                  <el-select v-model="search.subjectId" placeholder="选择学科" style="width: 250px" size="small" clearable>
                    <el-option v-for="item in conditions.xuekeList" :key="item.node" :label="item.text" :value="item.node"></el-option>
                  </el-select>
                </li>
                <li>
                  <em>选择目录：</em>
                  <el-cascader v-model="search.catalog" @change="handleChange" :options="
                      sectionData.filter((el) => el.id == search.sectionId)[0]
                        ? sectionData
                            .filter((el) => el.id == search.sectionId)[0]
                            .children.filter((el) => el.id == search.subjectId)[0]
                          ? sectionData
                              .filter((el) => el.id == search.sectionId)[0]
                              .children.filter((el) => el.id == search.subjectId)[0]
                              .children
                          : []
                        : []
                    " :props="props" size="small" style="width: 250px"></el-cascader>
                </li>

                <li>
                  <em>资源类型：</em>
                  <div style="display: inline-block; width: 830px">
                    <el-radio-group v-model="search.resourceTypeId" size="small">
                      <el-radio-button label="">全部</el-radio-button>
                      <el-radio-button v-for="(item, i) in conditions.ziyuanleibieList" :key="'resource' + i" :label="item.code">{{ item.name }}
                      </el-radio-button>
                    </el-radio-group>
                  </div>
                </li>

                <li>
                  <em>文档类型：</em>
                  <div style="display: inline-block; width: 830px">
                    <el-radio-group v-model="search.fileType" size="small">
                      <el-radio-button label="">全部</el-radio-button>
                      <el-radio-button v-for="(item, i) in conditions.wendangleixingList" :key="'resource' + i" :label="item.key">{{ item.value }}
                      </el-radio-button>
                    </el-radio-group>
                  </div>
                </li>
              </template>
              <template v-if="search.approvalState == 2">
                <li>
                  <em>专题名称：</em>
                  <el-select size="small" v-model="search1.thematicTypeId" placeholder="请选择" filterable>
                    <el-option v-for="item in conditions.zhuantiList" :key="item.id" :label="
                        item.typeName.length > 10
                          ? item.typeName.substring(0, 10) + '...'
                          : item.typeName
                      " :value="item.id">
                    </el-option>
                  </el-select>
                </li>
                <li>
                  <em>文档类型：</em>
                  <div style="display: inline-block; width: 830px">
                    <el-radio-group v-model="search1.fileType" size="small">
                      <el-radio-button label="">全部</el-radio-button>
                      <el-radio-button v-for="(item, i) in conditions.wendangleixingList" :key="'resource' + i" :label="item.key">{{ item.value }}
                      </el-radio-button>
                    </el-radio-group>
                  </div>
                </li>
              </template>
              <template v-if="search.approvalState == 3">
                <li>
                  <em>资源名称：</em>
                  <el-input v-model="search2.resourceName" size="small" style="width: 250px" placeholder="请输入内容"></el-input>
                </li>
              </template>
            </ul>
          </div>
        </div>
      </div>
      <div class="bg1">
        <div class="contentBox">
          <div class="bd ys4" style="min-height: 520px">
            <ul v-if="tableData.length > 0">
              <li v-for="(d, i) in tableData" :key="i">
                <div class="icon">
                  <svg class="icon" aria-hidden="true" v-if="search.approvalState != 3">
                    <use :xlink:href="'#icontbd' + d.fileType"></use>
                  </svg>
                  <em v-if="
                      search.approvalState == 1 &&
                      (d.fileType == 1 || d.fileType == 2 || d.fileType == 3)
                    ">- {{ d.filePage }}页 -</em>
                  <el-image v-if="search.approvalState == 3" class="b_img" fit="cover"
                            :src="d.coverUrl?uploadUrl+d.coverUrl:require('@/assets/img/vedioCover.png')"></el-image>
                </div>
                <div class="title">
                  <h5 @click="yulan(d, search.approvalState,false)" v-if="search.approvalState == 3">
                    {{ d.resourceName }}
                  </h5>
                  <h5 @click="yulan(d, search.approvalState)" v-else>
                    {{ d.resourceName }}
                  </h5>
                  <span class="catalog" v-if="search.approvalState == 1">
                    <i class="ka">{{ d.resourceTypeName }}</i>
                    <i v-if="d.versionName">{{ d.versionName }}</i>
                    <i v-if="d.volumeName">/{{ d.volumeName }}</i>
                    <i v-if="d.firstChapterName">/{{ d.firstChapterName }}</i>
                    <i v-if="d.secondChapterName">/{{ d.secondChapterName }}</i>
                    <i v-if="d.thirdChapterName">/{{ d.thirdChapterName }}</i>
                    <i v-if="d.fourthChapterName">/{{ d.fourthChapterName }}</i>
                  </span>
                  <span class="attribute" v-else-if="search.approvalState == 2">
                    <i class="blue">专题名称：</i>
                    <i>{{ d.thematicTypeName }}</i>
                  </span>
                  <!-- <span class="attribute">上传人：{{ d.userName }}</span>
                  <span class="attribute"
                    >时间：{{
                      (d.createTime ? d.createTime : d.favoriteDownTime).split(
                        " "
                      )[0]
                    }}</span
                  >
                  <span class="attribute">浏览量 ：{{ d.visitedNumber }}</span>
                  <span class="attribute">收藏量：{{ d.favoriteNumber }}</span> -->
                  <!-- <span class="school">学校：{{ d.schoolName }}</span>
                <span class="author">作者：{{ d.createUserName }}</span> -->
                  <div>
                    <span class="attribute">时间：{{
                        (d.createTime ? d.createTime : d.favoriteDownTime).split(" ")[0]
                      }}</span>
                    <span class="attribute">下载量：{{ d.downloadNumber }}</span>
                    <span class="attribute">收藏量：{{ d.favoriteNumber }}</span>
                    <span class="attribute" v-if="search.approvalState != 3">浏览量：{{ d.visitedNumber }}</span>
                    <span class="attribute" v-if="search.approvalState != 3">大小：{{ unit(d.fileSize) }}</span>
                  </div>
                  <span class="attribute" v-if="search.approvalState == 1">学校：{{ d.schoolName }}</span>
                  <span class="attribute" v-if="search.approvalState == 1">作者：{{ d.createUserName ? d.createUserName : d.userName }}</span>
                </div>
                <div class="operate">
                  <el-button type="primary" v-if="search.approvalState==3" @click="handleDownload(d)" :disabled="d.fileUrl == '' || d.fileUrl == null"
                             size="small">下载</el-button>
                  <el-button type="primary" v-else @click="downLoad(d, search.approvalState == 1 ? 1 : 3)" :disabled="d.fileUrl == '' || d.fileUrl == null"
                             size="small">下载</el-button>
                  <el-button type="text" @click="quxiaoshoucang(d)" size="small">取消收藏</el-button>
                  <el-button type="text" v-if="
                      userModule.roles.filter((el) =>
                        [
                          'ClassManager',
                          'Guardian',
                          'SchoolManager',
                          'Student',
                          'Teacher',
                          'TeacherCourse',
                        ].includes(el.id)
                      ).length > 0 &&
                      search.approvalState == 1 &&
                      [1, 3, 4].includes(d.fileType)
                    " @click="songyin(d)" size="small">送印</el-button>
                </div>
              </li>
            </ul>
            <div class="unusual" v-else>
              <span class="pt320">暂无内容</span>
            </div>
            <el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange" background layout="total, sizes, prev, pager, next, jumper"
                           :total="pages.pageAll" :page-size="pages.pageSize"></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="送印" :visible.sync="dialogFormVisible">
      <el-form :model="form">
        <el-form-item label="方式">
          <el-radio-group v-model="form.printType">
            <el-radio :label="1">单面打印</el-radio>
            <el-radio :label="2">双面打印</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="数量">
          <el-input-number v-model="form.printNumber" :step="1" :min="1" label="份"></el-input-number>
        </el-form-item>
        <el-form-item label="纸张类型">
          <el-radio-group v-model="form.paperType">
            <el-radio :label="paperType.key" :key="i" v-for="(paperType, i) in conditions.paperTypeList">{{ paperType.value }}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注">
          <el-input type="textarea" maxlength="100" show-word-limit :rows="5" placeholder="请输入内容" v-model="form.remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="tijiaosongyin">确 定</el-button>
      </div>
    </el-dialog>
  </div>

  <!-- <yulan :watchType='watchType' :fileUrl='fileUrl' @watch-type="getWatchType"></yulan> -->
</template>

<script>
import date from "../../mixins/date";
import { mapState } from "vuex";
import yulan from "@/components/yulan";
import yulanmix from "../../mixins/yulan";
import downLoad from "../../mixins/downLoad";
export default {
  name: "collection",
  data() {
    return {
      dialogFormVisible: false,
      form: {
        id: "",
        resourceId: "",
        printType: 1,
        printNumber: 0,
        remark: "",
        paperType: "",
      },
      props: {
        value: "id",
        label: "label",
        checkStrictly: true,
      },
      ccc: "我的收藏",
      tableshou: true,
      search: {
        approvalState: 1,
        approvalSchoolId: "",
        sectionId: "",
        subjectId: "",
        versionId: "",
        gradeId: "",
        volumeId: "",
        relationDataId: "",
        dataId: "",
        chapterId: "",
        resourceTypeId: "",
        fileType: "",
        resourceName: "",
        firstChapterId: "",
        secondChapterId: "",
        thirdChapterId: "",
        fourthChapterId: "",
        startTime: "",
        endTime: "",
        page: 1,
        size: 10,
      },
      search1: {
        fileType: "",
        thematicTypeId: "",
        page: 1,
        size: 10,
        resourceName: "",
      },
      search2: {
        page: 1,
        size: 10,
        resourceName: "",
      },
      conditions: {
        xuexiaoList: [],
        xueduanList: [],
        nianjiList: [],
        xuekeList: [],
        banbenList: [],
        ceciList: [],
        zhangjieList: [],
        ziyuanleibieList: [],
        wendangleixingList: [],
        zhuantiList: [],
        paperTypeList: [],
      },
      tableData: [],
      tableData1: [],
      pages: {
        pageIndex: 1,
        pageAll: 100,
        pageSize: 10,
      },
      tabH: 0,
      watchType: null,
      fileUrl: "",
      uploadUrl: "",
      previewUrl: "",
      sectionData: [],
      shrink: true,
    };
  },
  components: { yulan },
  mixins: [yulanmix, downLoad],
  watch: {
    "search.approvalState": {
      handler(v) {
        this.tableData = [];
        this.tableData1 = [];
        this.search.resourceName = "";
        if (v == 1) {
          this.getCollectionList();
        } else if (v == 2) {
          this.getZhuangti();
        } else if (v == 3) {
          this.getClassroomData();
        }
      },
    },
    "search.sectionId": {
      handler(v) {
        if (v) {
          this.search.gradeId = "";
          this.search.subjectId = "";
          this.search.versionId = "";
          this.search.volumeId = "";
          this.search.chapterId = "";
          this.conditions.nianjiList = [];
          this.conditions.xuekeList = [];
          this.conditions.banbenList = [];
          this.conditions.ceciList = [];
          this.conditions.zhangjieList = [];
          this.getNianJi();
          this.getXueKe();
        } else {
          this.search.gradeId = "";
          this.search.subjectId = "";
          this.search.versionId = "";
          this.search.volumeId = "";
          this.search.chapterId = "";
          this.conditions.nianjiList = [];
          this.conditions.xuekeList = [];
          this.conditions.banbenList = [];
          this.conditions.ceciList = [];
          this.conditions.zhangjieList = [];
        }
        this.getCollectionList();
      },
    },
    "search.subjectId": {
      handler(v) {
        if (v) {
          this.search.versionId = "";
          this.search.volumeId = "";
          this.search.chapterId = "";
          this.conditions.banbenList = [];
          this.conditions.ceciList = [];
          this.conditions.zhangjieList = [];
          this.getBanben();
        } else {
          this.search.versionId = "";
          this.search.volumeId = "";
          this.search.chapterId = "";
          this.conditions.banbenList = [];
          this.conditions.ceciList = [];
          this.conditions.zhangjieList = [];
        }
        this.getCollectionList();
      },
    },
    "search.versionId": {
      handler(v) {
        if (v) {
          this.search.volumeId = "";
          this.search.chapterId = "";
          this.conditions.ceciList = [];
          this.conditions.zhangjieList = [];
          this.getCeCi();
        } else {
          this.search.volumeId = "";
          this.search.chapterId = "";
          this.conditions.ceciList = [];
          this.conditions.zhangjieList = [];
        }
        this.getCollectionList();
      },
    },
    "search.volumeId": {
      handler(v) {
        if (v) {
          this.search.relationDataId = v;
          this.search.dataId = v;
          this.search.chapterId = "";
          this.conditions.zhangjieList = [];
          this.getZhangJie();
        } else {
          this.search.relationDataId = "";
          this.search.dataId = "";
          this.search.chapterId = "";
          this.conditions.zhangjieList = [];
        }
        this.getCollectionList();
      },
    },
    "search.firstChapterId": {
      handler(v) {
        this.getCollectionList();
      },
    },
    "search1.fileType": {
      handler(v) {
        this.getZhuangti();
      },
    },
    "search1.thematicTypeId": {
      handler(v) {
        this.getZhuangti();
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.tabH = this.$refs.setH.clientHeight - 230;
    });
    this.getSchoolList();
    this.getXueDuan();
    this.getZiYuanLeiBie();
    this.getWenDangLeixing();
    this.getZhuanTiMingCheng();
    this.getCollectionList();
    this.getPaperType();
    this.uploadUrl = window.sessionStorage.getItem("fileJavaServerUrl");
    this.previewUrl = window.sessionStorage.getItem("previewUrl");
    this.sectionData = JSON.parse(window.sessionStorage.getItem("sectionData"));
  },
  computed: {
    ...mapState(["userModule"]),
  },
  methods: {
    handleDownload(data) {
      this.$ajax
        .post("/server/third/resource/download", {
          resourceId: data.resourceId,
        })
        .then((res) => {
          this.getClassroomData();
          const a = document.createElement("a");
          a.setAttribute("href", this.uploadUrl + data.fileUrl);
          a.setAttribute("download", data.resourceName);
          a.setAttribute("target", "_blank");
          a.click();
        });
    },
    handleSearch() {
      this.shrink = true;
      if (this.search.approvalState == 1) {
        this.getCollectionList();
      }
      if (this.search.approvalState == 2) {
        this.getZhuangti();
      }
      if (this.search.approvalState == 3) {
        this.getClassroomData();
      }
    },
    getClassroomData() {
      this.$ajax
        .post("/server/my/favorite/getThirdResourceList", this.search2)
        .then((res) => {
          this.tableData = res.list;
          this.pages.pageAll = res.total;
          this.tableshou = true;
        });
    },
    getPaperType() {
      this.$ajax.post("/common/load/paper/type").then((res) => {
        this.conditions.paperTypeList = res;
        this.form.paperType = 1;
      });
    },
    songyin(obg) {
      this.dialogFormVisible = true;
      this.form.resourceId = obg.resourceId;
      this.form.id = "";
      this.form.printType = 2;
      this.form.printNumber = "";
      this.form.remark = "";
    },
    // 提交送印
    tijiaosongyin() {
      let urlLink = `/server/my/upload/printResourceById `;
      this.$ajax.post(urlLink, this.form).then((res) => {
        console.log("送印资源返回", res);
        if (res == "操作成功") {
          this.$message({
            message: "送印成功",
            type: "success",
          });
          this.dialogFormVisible = false;
          this.getUploadList();
        }
      });
    },
    handleChange(e) {
      if (e[0]) {
        this.search.versionId = e[0];
      } else {
        this.search.versionId = "";
      }
      if (e[1]) {
        this.search.volumeId = e[1];
      } else {
        this.search.volumeId = "";
      }
      if (e[2]) {
        this.search.firstChapterId = e[2];
      } else {
        this.search.firstChapterId = "";
      }
      if (e[3]) {
        this.search.secondChapterId = e[3];
      } else {
        this.search.secondChapterId = "";
      }
      if (e[4]) {
        this.search.thirdChapterId = e[4];
      } else {
        this.search.thirdChapterId = "";
      }
      if (e[5]) {
        this.search.fourthChapterId = e[5];
      } else {
        this.search.fourthChapterId = "";
      }
    },
    unit(v) {
      let arr = ["B", "KB", "MB", "GB", "TB"];
      let i = 0;
      while (v > 1024) {
        i++;
        v = Math.floor((v * 100) / 1024) / 100;
      }
      return v + arr[i];
    },
    // // 预览点击
    // yulan(obg){
    //   if(obg.fileType<4){
    //     this.fileUrl = window.sessionStorage.getItem("previewUrl") + window.sessionStorage.getItem("uploadUrl") + obg.fileUrl;
    //     this.watchType = obg.fileType
    //   }else if(obg.fileType==4){
    //     this.fileUrl =  window.sessionStorage.getItem("uploadUrl") + obg.fileUrl;
    //     this.watchType = obg.fileType
    //   }else if(obg.fileType==5){
    //     this.fileUrl =  window.sessionStorage.getItem("uploadUrl") + obg.fileUrl;
    //     this.watchType = obg.fileType
    //   }else{

    //   }
    // },
    // // 获取子节点返回的查看值
    // getWatchType(event){
    //   console.log(event);
    //   this.watchType = event;
    // },
    //清空查询条件
    clear() {
      this.search.school = "";
      this.search.sectionId = "";
      this.search.gradeId = "";
      this.search.subjectId = "";
      this.search.versionId = "";
      this.search.volumeId = "";
      this.search.chapterId = "";
      this.search.resourceTypeId = "";
      this.search.fileType = "";
      this.search.resourceName = "";
      this.search1.thematicTypeId = "";
      this.search1.fileType = "";
      this.search.firstChapterId = "";
      this.search.secondChapterId = "";
      this.search.thirdChapterId = "";
      this.search.fourthChapterId = "";
      this.search2.resourceName = "";
    },
    // 获取学校列表
    getSchoolList() {
      let urlLink = `/common/load/school`;
      let param = {};
      this.$ajax.post(urlLink, param).then((res) => {
        console.log("获取学校", res);
        this.conditions.xuexiaoList = res;
      });
    },
    // 获取学段
    getXueDuan() {
      let urlLink = `/common/catalog/load/section`;
      this.$ajax.post(urlLink).then((res) => {
        console.log("获取学段", res);
        this.conditions.xueduanList = res;
      });
    },
    // 获取年级
    getNianJi() {
      let urlLink = `/common/catalog/load/grade`;
      let param = this.search;
      this.$ajax.post(urlLink, param).then((res) => {
        console.log("获取年级", res);
        this.conditions.nianjiList = res;
      });
    },
    // 获取学科
    getXueKe() {
      let urlLink = `/common/catalog/load/subject`;
      let param = this.search;
      this.$ajax.post(urlLink, param).then((res) => {
        console.log("获取学科", res);
        this.conditions.xuekeList = res;
      });
    },
    // 获取版本
    getBanben() {
      let urlLink = `/common/catalog/load/version`;
      let param = this.search;
      this.$ajax.post(urlLink, param).then((res) => {
        console.log("获取版本", res);
        this.conditions.banbenList = res;
      });
    },
    // 获取册次
    getCeCi() {
      let urlLink = `/common/catalog/load/volume`;
      let param = this.search;
      this.$ajax.post(urlLink, param).then((res) => {
        console.log("获取册次", res);
        this.conditions.ceciList = res;
      });
    },
    // 获取章节
    getZhangJie() {
      let urlLink = `/common/catalog/load/chapter`;
      let param = this.search;
      this.$ajax.post(urlLink, param).then((res) => {
        console.log("获取章节", res);
        this.conditions.zhangjieList = res;
      });
    },
    // 获取资源类别
    getZiYuanLeiBie() {
      let urlLink = `/common/load/resource/type`;
      this.$ajax.post(urlLink).then((res) => {
        console.log("获取资源类别", res);
        this.conditions.ziyuanleibieList = res;
      });
    },
    // 获取文档类型
    getWenDangLeixing() {
      let urlLink = `/common/load/file/type`;
      this.$ajax.post(urlLink).then((res) => {
        console.log("获取文档类型", res);
        this.conditions.wendangleixingList = res;
      });
    },
    // 获取专题名称列表
    getZhuanTiMingCheng() {
      let urlLink = `/server/my/favorite/getThematicTypeList`;
      this.$ajax.post(urlLink).then((res) => {
        console.log("获取专题名称", res);
        this.conditions.zhuantiList = res;
      });
    },
    handleSizeChange(v) {
      this.search.page = 1;
      this.search.size = v;
      this.search1.page = 1;
      this.search1.size = v;
      if (this.search.approvalState == 1) {
        this.getCollectionList();
      } else {
        this.getZhuangti();
      }
    },
    // 分页页码变动
    handleCurrentChange(v) {
      this.search1.page = v;
      this.search.page = v;
      if (this.search.approvalState == 1) {
        this.getCollectionList();
      } else {
        this.getZhuangti();
      }
    },
    // 获取收藏列表
    getCollectionList() {
      this.tableshou = false;
      let urlLink = `/server/my/favorite/getRecourseList`;
      this.$ajax.post(urlLink, this.search).then((res) => {
        console.log("获取收藏列表", res);
        console.log("获取收藏列表search", this.search);
        // this.conditions.wendangleixingList = res;
        this.tableData = res.list;
        this.pages.pageAll = res.total;
        this.tableshou = true;
      });
    },
    // 获取专题资源
    getZhuangti() {
      this.tableshou = false;
      let urlLink = `/server/my/favorite/getThematicResourceList`;
      this.search1.resourceName = this.search.resourceName;
      this.$ajax.post(urlLink, this.search1).then((res) => {
        console.log("获取专题资源列表", res);
        // this.conditions.wendangleixingList = res;
        this.tableData = res.list;
        this.pages.pageAll = res.total;
        this.tableshou = true;
      });
    },
    // 下载按钮
    xiazai(obg) {
      let urlLink =
        this.search.approvalState == 1
          ? `/server/my/favorite/download`
          : `/server/my/favorite/downLoadThematicResource`;
      let param = { resourceId: obg.resourceId };
      this.$ajax.post(urlLink, param).then((res) => {
        console.log("下载返回", res);
        if (res == "操作成功") {
          window.open(this.userModule.uploadUrl + obg.fileUrl);
        }
      });
    },
    // 取消收藏
    quxiaoshoucang(obg) {
      this.$confirm("确认取消收藏?", "信息提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let urlLink = `/server/my/favorite/cancelFavorite`;
          let param = { resourceId: obg.resourceId };
          this.$ajax.post(urlLink, param).then((res) => {
            console.log("取消收藏返回", res);
            if (res == "操作成功" && this.search.approvalState == 1) {
              this.getCollectionList();
            }
            if (res == "操作成功" && this.search.approvalState == 2) {
              this.getZhuangti();
            }
            if (res == "操作成功" && this.search.approvalState == 3) {
              this.getClassroomData();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消操作",
          });
        });
    },
  },
};
</script>

<style scoped>
.b_img {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/page/my/collection.vue